module.exports = __webpack_public_path__ + "img/mode_bg_2.f7e37a7d.jpeg";